'use client';

import { useState } from 'react';
import { ContactMModal, ContactPcModal } from '@/features/modal';
import { Benefit, Content, EnterprisePlan, Hero } from './components';
import { ContactFinal } from './components';
import { EnterpriseFooter } from './components';

const EnterpriseLanding = () => {
  const [contactMOpen, setContactMOpen] = useState(false);
  const [contactPcOpen, setContactPcOpen] = useState(false);

  const onOpenContact = (isMobile: boolean) => {
    if (isMobile) setContactMOpen(true);
    else setContactPcOpen(true);
  };

  return (
    <div style={{ backgroundColor: '#F9FAFB' }}>
      <Hero onOpenContact={onOpenContact} />
      <Benefit />
      <Content />
      <EnterprisePlan onOpenContact={onOpenContact} />
      <ContactFinal onOpenContact={onOpenContact} />
      <EnterpriseFooter />
      <ContactMModal open={contactMOpen} onClose={() => setContactMOpen(false)} />
      <ContactPcModal open={contactPcOpen} onClose={() => setContactPcOpen(false)} />
    </div>
  );
};

export default EnterpriseLanding;
